let jsid = 0

export default class TreeItem {

	constructor (props) {
		Object.assign(this, {
			jsid: ++jsid,
			id: null,
			name: '',
			enabled: true,
			children: []
		}, props)
	}
}

TreeItem.wrap = (props) => new TreeItem(props)

TreeItem.unwrap = (item) => {
	const unwrapped = Object.assign({}, item)
	delete unwrapped.jsid
	return unwrapped
}
